<template>
    <div class="tw-flex tw-flex-col tw-flex-1 tw-overflow-scroll tw-p-6" :class="{'tw-items-center tw-justify-center': question.type === 'true_false' || question.type === 'free_form'}">

        <!--<div class="tw-flex tw-flex-wrap tw-pb-6" v-if="question_media.length > 0">-->
            <!--<question-media v-for="media in question_media" :media="media" v-if="question.id === media.question_id" :key="media.id"></question-media>-->
        <!--</div>-->

        <div v-if="question">
            <poll_multiple_choice :question="question" :poll="poll" :edit="edit" :settings="settings"></poll_multiple_choice>
        </div>

        <div class="answer-confirmed-overlay tw-absolute tw-z-10 tw-top-0 tw-left-0 tw-w-full tw-h-full" v-if="answer_confirmed.is_confirmed && answer_confirmed.display"></div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        name: 'PollQuestion',

        props: ['question', 'poll', 'current_question_index', 'edit','settings'],

        computed: {
            ...mapState('poll',
                ['question_media',
                 'answer_confirmed']
            )
        },

        mounted() {
            this.getQuestionMedia();
            let media = this.$store.getters['quiz/getQuestionMedia'](this.question.id);

            if(media === false || typeof media === "undefined") {
                this.$store.dispatch('poll/getQuestionMedia', this.question.id);
            }
        },

        methods: {
            getQuestionMedia(){
                this.$store.dispatch('poll/getQuestionMedia', this.question.id);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .quiz-wrapper {
        .answer-confirmed-overlay {
            background: rgba(255, 255, 255, 0.4);
        }
    }
</style>